import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { ServiceHealth } from './types';
import { StatusPill } from './StatusBits';
import { formatCount, formatMs, formatPct } from './formatHealth';

export const ServiceStrip: React.FC<{ services: ServiceHealth[] }> = ({ services }) => {
  const navigate = useNavigate();
  return (
    <div className="overflow-hidden rounded-xl border border-[var(--border)] bg-[var(--card)] shadow-[var(--portal-shadow)]">
      <div className="flex items-center justify-between border-b border-[var(--border)] px-5 py-3">
        <div>
          <h2 className="text-sm font-semibold text-[var(--foreground)]">Cloud Run</h2>
          <p className="text-xs text-[var(--muted-foreground)]">Production API, wallet, and admin portal</p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/admin/system/services')}
          className="text-xs font-semibold text-[var(--mymoolah-blue)] hover:underline"
        >
          View services
        </button>
      </div>
      <div className="grid grid-cols-1 divide-y divide-[var(--border)] md:grid-cols-3 md:divide-x md:divide-y-0">
        {services.map((svc) => (
          <button
            key={svc.id}
            type="button"
            onClick={() => navigate('/admin/system/services')}
            className="flex items-start justify-between gap-3 px-5 py-4 text-left hover:bg-[var(--muted)]/40"
          >
            <div className="min-w-0">
              <p className="text-sm font-semibold text-[var(--foreground)]">{svc.label}</p>
              <p className="mt-0.5 truncate font-mono text-[11px] text-[var(--muted-foreground)]">
                {svc.cloudRunName}
              </p>
              <p className="mt-2 text-xs text-[var(--muted-foreground)]">
                {formatCount(svc.instances)} inst · p95 {formatMs(svc.p95Ms)} · 5xx {formatPct(svc.errorRatePercent, 2)}
              </p>
            </div>
            <StatusPill status={svc.status} />
          </button>
        ))}
      </div>
    </div>
  );
};
